import { render, staticRenderFns } from "./WeightField.vue?vue&type=template&id=f25b0baa&"
import script from "./WeightField.vue?vue&type=script&lang=js&"
export * from "./WeightField.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports